import React from "react";
import styled from "styled-components";

import { UIPane } from "js/react/components/UiComponents";

const LayoutContainer = styled.div`
    background-color: #EEE;
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 100%;
    height: 100%;
    flex: 1;
    min-height: 0;
    box-sizing: border-box;
    gap: 20px;
`;

export default function Layout({ children }: { children: React.ReactNode }) {
    return (
        <UIPane>
            <LayoutContainer>
                {children}
            </LayoutContainer>
        </UIPane>
    );
}
